import { useContext, useEffect } from 'react'
import { CoreIndustries } from '../../components/Public/Home/CoreIndustries'
import { Button } from '../../layouts/ui/Button'
import { UsersPage } from '../../components/Public/Home/UsersPage'
import { CareerGrowth } from '../../components/Public/Home/CareerGrowth'
import { OurMission } from '../../components/Public/Home/OurMission'
import { NextLevel } from '../../components/Public/Home/NextLevel'
// import JS1 from '../../assets/HomePage/Job Seeker1.png'
// import JS2 from '../../assets/HomePage/Job Seeker2.png'
// import JS3 from '../../assets/HomePage/Job Seeker3.png'
// import Recruiter1 from '../../assets/HomePage/Recruiter1.png'
import landingPage from '../../assets/HomePage/LandingImg.png'
// import Recruiter2 from '../../assets/HomePage/Recruiter2.png'
// import Recruiter3 from '../../assets/HomePage/Recruiter3.png'
// import PortalImage from '../../assets/HomePage/Center-Image.png'
import { DataProvider } from '../../store/ContextProvider'
import Loading from '../Loading'

export const Home = () => {

  // const [hovered, setHovered] = useState(false)
  const { isAuth, currentUser } = useContext(DataProvider)

  useEffect(() => {
    if (isAuth && currentUser) {
      if (currentUser.role === 'job-seeker') {
        window.location.href = '/dashboard'
      }
      else if (currentUser.role === "employer") {
        window.location.href = '/employer-dashboard'
      }
      else if (currentUser.role === "admin") {
        window.location.href = '/admin-dashboard'
      }
    }
  }, [isAuth, currentUser])

  if (isAuth == null || currentUser == null) return <Loading />

  return (
    <main className='relative overflow-x-hidden'>
      <div className="absolute  w-[312.6px] h-[294.31px] -top-[3%] right-[0%] -rotate-[2.26deg] bg-[#EFD2FF] blur-[130px] -z-10 sm:z-0"></div>
      <section className="p-[20px] lg:p-[64px]">
        <div className="flex flex-col items-center justify-center   lg:my-6    ">

          {/* Artwork wrapper */}
          {/* <div className=' py-[98px] lg:block hidden w-[600px] ' onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} >

            <div className='lg:w-[313px] lg:h-[314px] sm:w-[200px] sm:h-[200px] border-[2px] border-[#2C25C4] rounded-full absolute lg:top-[30px]  lg:left-[37px] sm:top-[30px]'></div>
            <div className='lg:w-[313px] lg:h-[314px] sm:w-[200px] sm:h-[200px] border-[2px] border-[#2C25C4] rounded-full absolute lg:top-[147px] lg:left-[15px] sm:top-[120px] sm:left-[40px]'></div>
            <div className='lg:w-[313px] lg:h-[314px]  sm:w-[200px] sm:h-[200px] border-[2px] border-[#2C25C4] rounded-full absolute lg:top-[160px] lg:left-[160px]'></div>
            <div className='lg:w-[313px] lg:h-[314px] sm:w-[200px] sm:h-[200px]  border-[2px] border-[#2C25C4] rounded-full absolute lg:top-[60px] lg:left-[263px]'></div>
            <div className='lg:w-[313px] lg:h-[314px] sm:w-[200px] sm:h-[200px] border-[2px]  rounded-full absolute top-[85px] lg:left-[124px] z-40 bg-black'><img src={PortalImage} alt='img' /></div>


            <img src={JS1} alt='Job Seeker1' className={`absolute sm:w-[40px] sm:h-[40px] sm:top-[] ${hovered ? 'lg:w-[62px] lg:h-[62px] left-[172px] top-[-10px]' : 'lg:w-[90px] lg:h-[90px]  left-[160px] top-[-10px]'} duration-1000 transition-all`} />
            <img src={Recruiter3} alt='Recruiter1' className={`absolute sm:w-[40px] sm:h-[40px] ${hovered ? 'lg:w-[90px] lg:h-[90px] left-[6px] top-[192px]' : 'lg:w-[62px] lg:h-[62px] left-[6px] top-[192px]'} duration-1000 transition-all`} />
            <img src={JS2} alt='Job Seeker2' className={`absolute sm:w-[40px] sm:h-[40px]  ${hovered ? 'lg:w-[62px] lg:h-[62px] left-[65px] top-[412px] ' : 'lg:w-[90px] lg:h-[90px] left-[58px] top-[408px]'} duration-1000 transition-all`} />
            <img src={Recruiter2} alt='Recruiter2' className={`absolute sm:w-[40px] sm:h-[40px] ${hovered ? 'lg:w-[90px] lg:h-[90px] left-[444px] top-[36px]' : 'lg:w-[62px] lg:h-[62px] left-[450px] top-[59px]'}   duration-1000 transition-all`} />
            <img src={JS3} alt='Job Seeker3' className={`absolute sm:w-[40px] sm:h-[40px] ${hovered ? 'lg:w-[62px] lg:h-[62px] left-[507px] top-[264px]' : 'lg:w-[90px] lg:h-[90px] left-[500px] top-[270px]'}   duration-1000 transition-all`} />
            <img src={Recruiter1} alt='Recruiter3' className={`absolute sm:w-[40px] sm:h-[40px] ${hovered ? 'top-[412px] left-[334px] lg:h-[90px] lg:w-[90px]' : 'lg:w-[62px] lg:h-[62px] left-[357px] top-[442px]'} duration-1000 transition-all`} />

          </div> */}


          {/* Text column */}
          <div className=" max-w-[790px] md:text-center mt-8 lg:mt-0 px-7">
            <h1 className="font-semibold text-[24px] sm:text-[35px] lg:text-[48px] leading-snug">
              Where Talent Meets Opportunity<br /> <span className=" text-[#2C25C4] px-1 ">Instantly.</span>
            </h1>
            <p className="py-5 text-[#454545] text-sm sm:text-base leading-relaxed md:text-center">
              Whether you’re chasing your first job or searching for top talent,
              CareerConnects AI finds the right people at the right time. Fast-track
              hiring with smart invites and zero clutter.
            </p>
            <div className='flex justify-center'>
              <Button
                variant="primary"
                className="w-[200px] sm:w-[260px] h-[44px] sm:h-[48px] text-white md:text-center"
                onClick={() => window.location.href = '/signup'}
              >
                Get Started
              </Button>
            </div>
          </div>

          <img src={landingPage} alt="Portal" className="w-[600px]  h-full object-cover" />


          {/* <div className="mx-auto lg:ml-40 mt-10 w-full max-w-[600px] relative aspect-[600/520] lg:hidden"> */}
          {/* Circles */}
          {/* <div className="absolute border-2 border-[#2C25C4] rounded-full"
              style={{ width: "52%", height: "60%", top: "6%", left: "6%" }} />
            <div className="absolute border-2 border-[#2C25C4] rounded-full"
              style={{ width: "52%", height: "60%", top: "28%", left: "2%" }} />
            <div className="absolute border-2 border-[#2C25C4] rounded-full"
              style={{ width: "52%", height: "60%", top: "30%", left: "27%" }} />
            <div className="absolute border-2 border-[#2C25C4] rounded-full"
              style={{ width: "52%", height: "60%", top: "12%", left: "44%" }} /> */}

          {/* Center circle with image */}
          {/* <div className="absolute rounded-full border-2  bg-black overflow-hidden"
              style={{ width: "52%", height: "60%", top: "18%", left: "21%" }}>
              <img src={PortalImage} alt="Portal" className="w-full h-full object-cover" />
            </div> */}

          {/* Floating images */}
          {/* <img src={JS1} alt="Job Seeker1"
              className="absolute rounded-full object-cover"
              style={{ width: "15%", height: "15%", top: "-2%", left: "27%" }} />

            <img src={Recruiter3} alt="Recruiter1"
              className="absolute rounded-full object-cover"
              style={{ width: "10%", height: "10%", top: "37%", left: "1%" }} />

            <img src={JS2} alt="Job Seeker2"
              className="absolute rounded-full object-cover"
              style={{ width: "15%", height: "15%", top: "78%", left: "10%" }} />

            <img src={Recruiter2} alt="Recruiter2"
              className="absolute rounded-full object-cover"
              style={{ width: "10%", height: "10%", top: "11%", left: "75%" }} />

            <img src={JS3} alt="Job Seeker3"
              className="absolute rounded-full object-cover"
              style={{ width: "15%", height: "15%", top: "52%", left: "83%" }} />

            <img src={Recruiter1} alt="Recruiter3"
              className="absolute rounded-full object-cover"
              style={{ width: "10%", height: "10%", top: "85%", left: "60%" }} /> */}
          {/* </div> */}


        </div>
      </section>


      
      <CoreIndustries />
      <UsersPage />
      <CareerGrowth />
      <OurMission />
      <NextLevel />

    </main>
  )
}
